<template>
  <v-container id="Pagos-lista-forms" fluid tag="section">
    <base-material-card color="#ac8a2e" icon="mdi-text-box-multiple" inline class="px-5 py-3" title="Pagos">
      <template v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="goToNewPagoForm('new', 0)">
          <v-icon large color="#ac8a2e">
            mdi-text-box-plus
          </v-icon>
        </v-btn>
      </template>
      <v-row align="end" justify="end">
        <v-col cols="5">
          <v-text-field v-model="buscar" append-icon="mdi-magnify" class="ml-auto" color="gold" label="Buscar" hide-details single-line style="max-width: 250px;" />
        </v-col>
      </v-row>
      <v-divider class="mt-3" />
      <v-data-table
        :page="pagos.page"
        :page-count="pagos.last_page"
        :headers="headers"
        :items="pagos.data"
        :search.sync="buscar"
        :server-items-length="pagos.total"
        :sort-by="sortby"
        :sort-desc="sortdesc"
        :footer-props="{
          itemsPerPageOptions: itemsPerPage
        }"
        disable-sort
        @update:options="getData($event)"
        @click:row="showItem"
      >
        <template #item="{ item }">
          <tr>
            <td class="text-start">
              {{ item.fecha }}
            </td>
            <td class="text-start">
              {{ generarNumero(item) }}
            </td>
            <td class="text-start">
              {{ item.fullName }}
            </td>
            <td class="text-start">
              {{ item.nombreStaff }}
            </td>
            <td class="text-start">
              {{ item.nombreContacto }}
            </td>
            <td class="text-start">
              {{ montoMoneda(item) }}
            </td>
            <td class="text-end">
              <v-tooltip content-class="top" top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="showItem(item)">
                    mdi-file-pdf-box
                  </v-icon>
                </template>
                <span>Pdf</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import GeneradorPdfRecibojs from '../../mixins/generadorPdfRecibo'
  import confirm from '../../components/confirm'
  export default {

    components: {
      confirm,
    },

    mixins: [GeneradorPdfRecibojs],

    data () {
      return {
        op: {},
        monedas: [],
        itemsPerPage: [5, 10, 15],
        buscar: '',
        typingTimer: {},
        headers: [
          { text: 'Fecha', align: 'start', sortable: true },
          { text: 'Número', align: 'start' },
          { text: 'Jugador' },
          { text: 'Staff' },
          { text: 'Otros' },
          { text: 'Monto' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        sortby: ['fecha'],
        sortdesc: [true],
        pagos: [],
      }
    },
    computed: {

    },
    watch: {
      buscar () {
        clearTimeout(this.typingTimer)
        this.typingTimer = setTimeout(() => this.readDataFromAPI(1, this.op.itemsPerPage), 1000)
      },
    },
    created () {
      this.getMoneda()
    },
    methods: {
      getMoneda () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => { this.monedas = response })
      },
      getData (data) {
        this.readDataFromAPI(data.page, data.itemsPerPage)
      },

      readDataFromAPI: async function (page = 1, itemsPerPage = 10) {
        this.$store.dispatch('axiosMod/getData', { url: '/api/pagos_get' + '?page=' + page + '&itemsPerPage=' + itemsPerPage + '&filtro=' + this.buscar }).then(response => {
          this.pagos = response
        })
      },

      generarNumero (item) {
        return (('00000000' + item.id).slice(-8))
      },

      montoMoneda (item) {
        return (this.simboloMoneda(item.moneda_id) + ' ' + item.monto)
      },

      simboloMoneda (monedaId) {
        return (this.monedas.length !== 0) ? this.monedas.find(e => e.id === monedaId).simbolo : '$'
      },
      showItem (item) {
        this.generarPdfPago(item.id)
      },

      goToNewPagoForm (modeVal, idRecibo) {
        this.$router.push({ name: 'Pagos', params: { id: idRecibo, mode: modeVal } })
      },

    },
  }
</script>

<style>
  .style-2 {
  background-color:rgb(240, 52, 52)
}
</style>
